module.exports = __webpack_public_path__ + "static/img/chanta (23).d77fa17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (23).jpg
// module id = P6Jz
// module chunks = 0